/* ============================================================
   YUVENLIFE — Cart UI + Nav  (vanilla, zero-dep)
   ------------------------------------------------------------
   DOM-/Render-Schicht. Cart-Logik lebt jetzt in window.YuvenCart
   (yuvenlife-cart-state.js) gegen die Shopify Storefront-API.
   Diese Datei: rendert den confirmed/degraded Cart, verdrahtet Klicks,
   und behält Headline-Toggle + Nav-Toggle unverändert.
   DOM-Hooks (data-*) bleiben stabil — Störungsfrei (kein Newsletter/Cross-Sell).
   ============================================================ */
(function () {
  "use strict";

  var html = document.documentElement;
  var $  = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var IMG_FALLBACK = "/bilder/yuvenlife-flasche-keyvisual.png";

  function eur(n) { return (Number(n) || 0).toFixed(2).replace(".", ",") + " €"; }
  function esc(s) { return String(s == null ? "" : s).replace(/[&<>"]/g, function (c) { return ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" })[c]; }); }
  function pioneerWaitlistMarkup() {
    return '<section id="pionier-warteliste" data-pioneer-waitlist aria-labelledby="pionier-warteliste-title" style="margin:10px 0 14px;padding:14px;border:1px solid rgba(32,32,32,.18);border-radius:14px;background:#fff8f3">' +
      '<p style="margin:0 0 6px;font-size:12px;letter-spacing:.08em;text-transform:uppercase">Pionier-Runde 01</p>' +
      '<h3 id="pionier-warteliste-title" style="margin:0 0 8px;font-size:20px;line-height:1.2">Unsere erste Pionier-Runde ist komplett.</h3>' +
      '<p style="margin:0 0 14px;line-height:1.45">Alle zehn Plätze sind vergeben. Lass dich jetzt für die nächste Pionier-Runde vormerken.</p>' +
      '<form method="post" action="/contact#pionier-warteliste" accept-charset="UTF-8">' +
        '<input type="hidden" name="form_type" value="customer">' +
        '<input type="hidden" name="utf8" value="✓">' +
        '<input type="hidden" name="contact[tags]" value="newsletter,pionier-warteliste">' +
        '<label for="pionier-email" style="display:block;margin:0 0 6px;font-size:14px">E-Mail-Adresse</label>' +
        '<div style="display:flex;gap:8px;flex-wrap:wrap">' +
          '<input id="pionier-email" type="email" name="contact[email]" autocomplete="email" placeholder="deine@email.de" required style="min-width:190px;flex:1;padding:11px 12px;border:1px solid #202020;border-radius:8px;background:#fff;color:#202020;font:inherit">' +
          '<button type="submit" style="padding:11px 16px;border:1px solid #202020;border-radius:8px;background:#202020;color:#fff;font:inherit;cursor:pointer">Vormerken lassen</button>' +
        '</div>' +
        '<label style="display:flex;gap:8px;align-items:flex-start;margin:12px 0 0;font-size:12px;line-height:1.4">' +
          '<input type="checkbox" required style="margin-top:3px">' +
          '<span>Ich möchte per E-Mail über die nächste Pionier-Runde und Neuigkeiten von yuvenlife informiert werden. Abmeldung jederzeit möglich. <a href="/policies/privacy-policy" style="color:inherit;text-decoration:underline">Datenschutz</a></span>' +
        '</label>' +
      '</form>' +
    '</section>';
  }

  /* Brand-Normalisierung für Warenkorb-Titel (André-Direktive 2026-07-04):
     immer "yuvenlife" lowercase, nie alte "Longevity"-Produktnamen. Greift auch
     bei No-Plan-Zeilen (alter Cart), die sonst den Shopify-Titel zeigen würden. */
  function brand(s) {
    return String(s == null ? "" : s)
      .replace(/yuvenlife®?/g, "yuvenlife")
      .replace(/Longevity Formulation[^·|,]*/gi, "functional nutrition oil")
      .replace(/Longevity Oil/gi, "functional nutrition oil");
  }

  /* ── Cart-Drawer öffnen/schließen (unverändert) ───────────── */
  function openCart(open) {
    html.setAttribute("data-cart-open", open ? "true" : "false");
    var drawer = $(".cart-drawer");
    if (drawer) drawer.setAttribute("aria-hidden", open ? "false" : "true");
    var overlay = $(".cart-overlay");
    if (overlay) { if (open) overlay.removeAttribute("hidden"); else overlay.setAttribute("hidden", ""); }
    if (open) { var c = $("[data-cart-close]"); if (c) c.focus(); }
  }

  /* ── Render aus YuvenCart-State ────────────────────────────── */
  function render(s) {
    // s = YuvenCart.getState()  (oder leerer Default falls Stack fehlt)
    var count = s ? s.count : 0;
    var total = s ? s.total : 0;
    var lines = s ? s.lines : [];
    var hasSubscription = lines.some(function (line) { return line.isSub; });
    var subscriptionHint = $(".cart-drawer__hint");
    if (subscriptionHint) subscriptionHint.hidden = !hasSubscription;

    $$("[data-cart-count]").forEach(function (el) {
      el.textContent = count;
      el.toggleAttribute && el.toggleAttribute("hidden", count === 0);
    });
    var t = $("[data-cart-total]"); if (t) t.textContent = eur(total);
    var ds = $("[data-discount-status]");
    if (ds) {
      var activeCode = s && s.discountCodes && s.discountCodes.filter(function (d) { return d.applicable; })[0];
      ds.textContent = activeCode ? "Rabattcode " + activeCode.code + " angewendet." : "";
    }

    // Checkout-Button-Zustand
    var co = $("[data-checkout]");
    if (co) {
      var can = s ? s.canCheckout : false;
      co.setAttribute("aria-disabled", can ? "false" : "true");
      co.classList.toggle("is-disabled", !can);
      if (s && s.status === "redirecting") co.setAttribute("aria-busy", "true"); else co.removeAttribute("aria-busy");
    }

    var body = $("[data-cart-body]");
    if (!body) return;

    var out = "";
    var pioneerClosed = s && s.status === "pioneer_closed" && s.message === "PIONEER10_CLOSED";
    var discountInput = $("[data-discount-code]");
    var discountBox = $(".cart-discount");
    var waitlist = $("[data-pioneer-waitlist]");
    if (pioneerClosed) {
      if (discountInput) discountInput.value = "";
      if (discountBox) discountBox.style.display = "none";
      if (ds) ds.hidden = true;
      if (!waitlist && ds) ds.insertAdjacentHTML("afterend", pioneerWaitlistMarkup());
    } else {
      if (discountBox) discountBox.style.display = "grid";
      if (ds) ds.hidden = false;
      if (waitlist) waitlist.remove();
    }
    // Status-Banner (error/degraded) — niemals still
    if (s && (s.status === "error" || s.status === "degraded") && s.message && !pioneerClosed) {
      out += '<p class="cart-banner cart-banner--' + s.status + '" role="alert">' + esc(s.message) + '</p>';
    }
    if (!lines.length) {
      out += '<p class="muted" data-cart-empty>dein warenkorb ist noch leer.</p>';
      body.innerHTML = out;
      return;
    }

    out += lines.map(function (l) {
      var price = l.lineTotal != null ? l.lineTotal : (l.priceEach || 0) * l.qty;
      return '<div class="cart-line">' +
        '<img class="cart-line__img" src="' + esc(l.image || IMG_FALLBACK) + '" width="120" height="120" alt="" loading="lazy">' +
        '<div><div class="cart-line__title">' + esc(brand(l.title)) + (l.isSub ? ' <span class="cart-line__abo">abo</span>' : '') + '</div>' +
        '<div class="cart-line__meta">' + esc(l.meta) + (l.qty > 1 ? " · " + l.qty + "×" : "") + '</div></div>' +
        '<div class="cart-line__price">' + eur(price) + '</div>' +
        '<button class="cart-line__remove" type="button" data-cart-remove="' + esc(l.plan || "") + '" aria-label="artikel entfernen">&times;</button>' +
        '</div>';
    }).join("");

    // MwSt/Versand-Hinweis steht bereits statisch im Drawer (kein Doppel) — André
    body.innerHTML = out;
  }

  /* ── Headline-Font-Toggle (Aeonik Fono ↔ RoobertSemiMono) — unverändert ── */
  function applyHeadline(h) {
    html.setAttribute("data-headline", h);
    $$("[data-headline-set]").forEach(function (b) {
      b.setAttribute("aria-pressed", String(b.getAttribute("data-headline-set") === h));
    });
  }
  var savedHeadline = (function () { try { return localStorage.getItem("yl-headline"); } catch (e) { return null; } })() || "roobert";

  /* ── globale Klick-Delegation ──────────────────────────────── */
  document.addEventListener("click", function (e) {
    var hset = e.target.closest("[data-headline-set]");
    if (hset) { var h = hset.getAttribute("data-headline-set"); try { localStorage.setItem("yl-headline", h); } catch (_) {} applyHeadline(h); return; }

    var addBtn = e.target.closest("[data-add-to-cart]");
    if (addBtn) {
      e.preventDefault();
      var plan = addBtn.getAttribute("data-plan");
      openCart(true);                              // wie bisher: Drawer sofort auf
      if (window.YuvenCart) {
        addBtn.setAttribute("aria-busy", "true"); addBtn.disabled = true;
        var done = function () { addBtn.removeAttribute("aria-busy"); addBtn.disabled = false; };
        var r = window.YuvenCart.add(plan);
        (r && r.then ? r : Promise.resolve()).then(done, done);
      }
      return;
    }

    if (e.target.closest("[data-cart-toggle]")) { e.preventDefault(); openCart(true); return; }
    if (e.target.closest("[data-cart-close]"))  { e.preventDefault(); openCart(false); return; }

    var rm = e.target.closest("[data-cart-remove]");
    if (rm) { e.preventDefault(); if (window.YuvenCart) window.YuvenCart.removeByPlan(rm.getAttribute("data-cart-remove")); return; }

    var discountBtn = e.target.closest("[data-discount-apply]");
    if (discountBtn) {
      e.preventDefault();
      var input = $("[data-discount-code]");
      if (window.YuvenCart && input) {
        discountBtn.disabled = true;
        var applied = window.YuvenCart.applyDiscount(input.value);
        Promise.resolve(applied).then(function () { discountBtn.disabled = false; }, function () { discountBtn.disabled = false; });
      }
      return;
    }

    var co = e.target.closest("[data-checkout]");
    if (co) {
      e.preventDefault();
      if (co.getAttribute("aria-disabled") === "true") { if (window.YuvenCart) window.YuvenCart.retry && window.YuvenCart.retry(); return; }
      if (window.YuvenCart) window.YuvenCart.checkout();
      return;
    }

    var navBtn = e.target.closest("[data-nav-toggle]");
    if (navBtn) {
      var nav = $("#nav"); if (!nav) return;
      var open = nav.getAttribute("data-open") === "true";
      nav.setAttribute("data-open", open ? "false" : "true");
      navBtn.setAttribute("aria-expanded", open ? "false" : "true");
    }
  });

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && html.getAttribute("data-cart-open") === "true") openCart(false);
  });

  /* ── Init ──────────────────────────────────────────────────── */
  applyHeadline(savedHeadline);
  if (window.YuvenCart) {
    window.YuvenCart.onChange(render);
    render(window.YuvenCart.getState());
    window.YuvenCart.init();
  } else {
    // Commerce-Stack nicht geladen → Seite bleibt funktional, Cart leer.
    console.warn("[yuven-cart] YuvenCart fehlt — Cart-UI im Leerlauf.");
    render(null);
  }
})();
